/* eslint-disable react/display-name */
import React from 'react';
import { Route } from 'react-router-dom';

export default ({ component: C, props: cProps, ...rest }) => {
    return <Route {...rest} render={props => <C {...props} {...cProps} />} />;
};



// WEBPACK FOOTER //
// ./src/components/hoc/AppliedRoute.js